import React, { useState, useEffect, useRef } from 'react';
import { Search, Filter, List, Grid } from 'lucide-react';

interface TableHeaderProps {
  onSearch?: (value: string) => void;
  onFilterClick?: () => void;
  onViewChange?: (view: 'list' | 'grid') => void;
  selectedView?: 'list' | 'grid';
}

const ComponentHeader: React.FC<TableHeaderProps> = ({ onSearch, onFilterClick, onViewChange, selectedView = 'list' }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      onSearch?.(searchQuery);
    }, 500);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchQuery]);

  return (
    <div className="flex flex-col md:flex-row md:items-center gap-3 p-4 bg-white rounded-md">
      {/* Title */}
      {/* <h2 className="text-lg font-semibold">{title}</h2> */}

      {/* Controls */}
      <div className="flex justify-end items-center gap-2 w-full">
        {/* Search */}
        <div className="flex items-center border rounded-md px-2 py-1 w-full md:w-64 ml-auto">
          <Search size={16} className="text-gray-400 mr-1" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full outline-none text-sm"
          />
        </div>

        {/* Filter button */}
        {/*<button onClick={onFilterClick} className="flex items-center gap-1 px-3 py-1 bg-gray-100 rounded-md hover:bg-gray-200 text-sm">
          <Filter size={16} /> Filter
        </button>*/}

        {/* Dropdown */}
        {/*<select className="border rounded-md px-2 py-1 text-sm">
          <option>Option 1</option>
          <option>Option 2</option>
        </select>*/}

        {/* View toggle */}
        <div className="flex items-center border rounded-md overflow-hidden">
          {/*<button onClick={() => onViewChange && onViewChange('list')} className={`p-2 ${selectedView === 'list' ? 'bg-gray-200' : ''}`}>
            <List size={16} />
          </button>*/}
          {/*<button onClick={() => onViewChange && onViewChange('grid')} className={`p-2 ${selectedView === 'grid' ? 'bg-gray-200' : ''}`}>
            <Grid size={16} />
          </button>*/}
        </div>
      </div>
    </div>
  );
};

export default ComponentHeader;
